import React from "react";
import { Link } from "react-router-dom";
import { Package, MessageCircle, Wrench, ArrowRight } from "lucide-react";

export default function ClienteHub() {
  return (
    <div className="min-h-screen bg-[#F7F7F5] flex flex-col items-center px-4 py-14" data-testid="cliente-hub">
      <div className="max-w-2xl w-full">
        <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#FF6700]">MontaJá · Cliente</div>
        <h1 className="font-heading font-extrabold text-4xl tracking-tighter mt-1 text-[#142766]">Área do Cliente</h1>
        <p className="text-sm text-muted-foreground mt-2">
          Acompanhe sua montagem, solicite um montador ou acesse o portal do seu pedido.
        </p>

        <div className="grid gap-4 mt-8">
          <Link to="/montadores" className="border-2 border-[#142766] bg-white p-5 flex items-center gap-4 hover:bg-[#FFF7F0] transition-colors"
            data-testid="hub-solicitar-montagem">
            <Wrench className="w-8 h-8 text-[#FF6700] shrink-0" />
            <div className="flex-1">
              <div className="font-bold text-[#142766]">Quero contratar uma montagem</div>
              <p className="text-xs text-muted-foreground mt-0.5">Solicite um montador profissional para seus móveis.</p>
            </div>
            <ArrowRight className="w-5 h-5 text-[#FF6700]" />
          </Link>

          <div className="border border-border bg-white p-5 flex items-center gap-4" data-testid="hub-acompanhar">
            <Package className="w-8 h-8 text-[#142766] shrink-0" />
            <div className="flex-1">
              <div className="font-bold text-[#142766]">Já tenho um pedido em andamento</div>
              <p className="text-xs text-muted-foreground mt-0.5">
                Use o <strong>link recebido no seu WhatsApp</strong> para confirmar dados, escolher datas e acompanhar
                a montagem em tempo real. O acesso é protegido e exclusivo do seu pedido.
              </p>
            </div>
          </div>

          <div className="border border-border bg-white p-5 flex items-center gap-4" data-testid="hub-suporte">
            <MessageCircle className="w-8 h-8 text-emerald-600 shrink-0" />
            <div className="flex-1">
              <div className="font-bold text-[#142766]">Precisa de ajuda?</div>
              <p className="text-xs text-muted-foreground mt-0.5">
                Fale com a central MontaJá pelo WhatsApp respondendo qualquer mensagem que recebeu, ou pelo canal
                indicado pela loja onde comprou.
              </p>
            </div>
          </div>
        </div>

        <Link to="/" className="inline-block mt-8 text-xs font-bold underline text-[#142766]" data-testid="hub-voltar">
          ← Voltar à página inicial
        </Link>
      </div>
    </div>
  );
}
